import { cloneDeep } from 'lodash';

const group = {
  base_info: {
    key: 'base_info',
    name: '基本信息',
    children: []
  },

  agent_adv: {
    key: 'agent_adv',
    name: '代理商和广告主',
    children: []
  },

  good_effect: {
    key: 'good_effect',
    name: '转化效果',
    children: []
  },

  impression_click_cost: {
    key: 'impression_click_cost',
    name: '展示、点击、消费',
    children: []
  },

  new_account: {
    key: 'new_account',
    name: '新开',
    children: []
  },

  plans_and_ideas: {
    key: 'plans_and_ideas',
    name: '计划和创意',
    children: []
  }
};

export function compose(data) {
  const arr = [];
  const _group = cloneDeep(group);
  for (let key in data) {
    const groupInfo = _group[key];
    if (groupInfo) {
      groupInfo.children = data[key];
      arr.push(groupInfo);
    } else {
      arr.push(data[key]);
    }
  }
  return arr;
}

export default group;
